/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-15 17:28:17
 */

import * as request from '@/utils/request'

export default {
  /**
   * getInport
   * @description 人员Excel导入
   * @author YQ
   * @date 2020/5/19
   * @param {*} data
   * @returns
   */
  getOssSign(data) {
    return request.get('/oss/sign', data)
  },
}